export const deletedHeartRunnerListState = {
    errorCode : 0,
    statusCode : 0,
    message : '',
    deletedHeartRunnerList : [],
    regionList:[],
}